module.exports = __webpack_public_path__ + "img/SlideShow03.015ecbbf.jpg";